export default "__VITE_ASSET__DjGfIkKx__"